import jQuery from "jquery";

const mixin = {
  methods: {
    panelClass: function (sidepanel) {
      var panelClass = "panel-open";
      if (sidepanel) {
        panelClass = panelClass + "_sidepanel";
      }
      return panelClass + "_" + this.$.uid;
    },
    addBodyClass: function (modalType) {
      let body = jQuery("body");
      let scrollbarWidth = window.innerWidth - document.body.clientWidth + "px";

      body
        .addClass("modal-open")
        .addClass(this.panelClass(this.sidepanel))
        .css("paddingRight", scrollbarWidth);
    },
    removeBodyClass: function () {
      var body = jQuery("body");
      body.removeClass(this.panelClass(this.sidepanel));

      // Remove modal-open class if all panel class are remove
      if (body.attr("class").indexOf("panel-open") < 0) {
        body.removeClass("modal-open").css("paddingRight", "");
      }
    }
  }
};

export default mixin;
